module.exports = __webpack_public_path__ + "static/img/3.52cdc1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/banner3/3.png
// module id = xM7h
// module chunks = 14